import { useEffect } from 'react';

import { useNavigate, useParams, useSearchParams } from 'react-router';

import downloadFile from '@/utils/downloadFile';

const FileDownload = () => {
  const ACTIVE_DATAHUB_PARAM = 'activeDataHub';
  const params = useParams();
  const navigate = useNavigate();
  const [urlSearchParams] = useSearchParams();
  const dataHubIdParam = urlSearchParams.get(ACTIVE_DATAHUB_PARAM) ?? '';

  useEffect(() => {
    if (params.fileId) {
      void downloadFile(params.fileId, params.fileName ?? 'export.xlsx');
    }
    navigate(`/data-hub/${dataHubIdParam}/summary`);
  }, [dataHubIdParam, navigate, params.fileId, params.fileName]);
  return <div />;
};

export default FileDownload;
